export class FirstAccessRequest {
    public userLogin: string;

    public oldPassword: string;

    public newPassword: string;

    public idHealthUnit: number;
}